import { isNil, isNull, isUndefined } from 'lodash-es';

import Colors from '@dynatrace/strato-design-tokens/colors';

import { MIN_MAX_PADDING } from '../constants.js';
import { useDefaultLabels } from '../hooks/useDefaultLabels.js';
import { useGaugeChartLabelsContext } from '../hooks/useGaugeChartLabelsContext.js';
import { GaugeLabel } from './GaugeLabel/GaugeLabel.js';
import { GaugeLabelsWrapper } from './GaugeLabelsWrapper/GaugeLabelsWrapper.js';
import { replaceSlashedZero } from '../../core/typographyStyles.sty.js';
import { useGaugeChartMinMaxLabelsPosition } from '../hooks/useGaugeChartMinMaxLabelsPosition.js';

interface GaugeLabelsProps {
  value: number;
}

export const GaugeLabels = ({ value }: GaugeLabelsProps) => {
  const { label, maxLabel, minLabel, valueLabel } =
    useGaugeChartLabelsContext();

  const { defaultLabel, defaultMaxLabel, defaultMinLabel, defaultValueLabel } =
    useDefaultLabels(value);

  const { maxLabelPosition, minLabelPosition } =
    useGaugeChartMinMaxLabelsPosition();

  return (
    <>
      <g
        fill={Colors.Text.Neutral.Default}
        id="internal-labels"
        className={replaceSlashedZero}
      >
        <GaugeLabelsWrapper>
          <GaugeLabel
            id="value-label"
            value={isNil(valueLabel) ? defaultValueLabel : valueLabel}
            responsive
          />
          {!isUndefined(label) && (
            <GaugeLabel
              id="label"
              value={isNull(label) ? defaultLabel : label}
              responsive
            />
          )}
        </GaugeLabelsWrapper>
      </g>

      <g fill={Colors.Text.Neutral.Default} id="min-max-labels">
        <GaugeLabel
          value={isNil(minLabel) ? defaultMinLabel : minLabel}
          x={minLabelPosition.x}
          y={minLabelPosition.y + MIN_MAX_PADDING}
          autoHide
        />
        <GaugeLabel
          value={isNil(maxLabel) ? defaultMaxLabel : maxLabel}
          x={maxLabelPosition.x}
          y={maxLabelPosition.y + MIN_MAX_PADDING}
          autoHide
        />
      </g>
    </>
  );
};
